import type { MaxWidth } from './types';

const maxWidth: MaxWidth = {
  xs: '640px',
  sm: '768px',
  md: '992px',
  lg: '1440px',
  xl: '1920px',
};

export { maxWidth };
